import Gate from '@/assets/graphical-elements/gate.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const GateIcon = ({className}: IconProps) => <Gate className={cn('fill-current', className)} />
